import React, { memo, useRef, useState } from "react";
import { Grid, IconButton } from "@material-ui/core";
import Title from "components/Admin/Title/Title";
import { useStyles } from "features/admin/styles";
import { Field, Fields, FieldsRow } from "features/admin/Products/types";
import SubTitle from "components/Admin/Title/SubTitle";
import { MdRefresh, MdSave, MdChevronLeft } from "react-icons/md";
import { useForm } from "react-hook-form";
import {
  FIELDS,
  Form,
  ProgressBar,
  SubmitButton,
  TitleContainer,
  Zone,
  BorderLinearProgress,
} from "components/Admin/InputFields/utils";

import { useNavigate } from "react-router-dom";
import Preloader from "components/Preloader/Preloader";
import styled from "styled-components";
interface AdminFormProps {
  formTitle: string;
  onSubmit: (data: any) => void;
  progress: number;
  product?: FieldsRow[];
  field?: Fields;
  inModal?: boolean;
}

const AdminForm: React.FC<AdminFormProps> = ({
  formTitle,
  onSubmit,
  product,
  progress,
  field,
  inModal,
}) => {
  const [resetForm, setResetForm] = useState(false);
  const classes = useStyles();
  const { handleSubmit, setValue, control, errors } = useForm();
  const formRef = useRef<HTMLFormElement>(null);
  const navigate = useNavigate();
  const isEditPage = window.location.pathname.includes("edit");
  const productColumns = product
    ? product.reduce<Fields[][]>((columns, row) => {
        row.row.forEach((section, columnIndex) => {
          if (!columns[columnIndex]) {
            columns[columnIndex] = [];
          }
          columns[columnIndex].push(section);
        });
        return columns;
      }, [])
    : [];

  const renderFields = (field: Field, idx: number) => {
    // if (field.type === "internal_bodies") return <></>;
    const Field = FIELDS[field.type];
    return (
      <Field
        item={field}
        key={idx}
        control={control}
        reset={isEditPage ? undefined : resetForm}
        setValue={setValue}
        errors={errors}
        disabled={field.disabled}
      />
    );
  };

  const reset = () => {
    setResetForm(!resetForm);
  };

  return (
    <>
      <TitleContainer>
        {!inModal && (
          <>
            <IconButton aria-label="Назад" onClick={() => navigate(-1)}>
              <MdChevronLeft />
            </IconButton>
            {!isEditPage && (
              <IconButton aria-label="Обнови" onClick={reset}>
                <MdRefresh />
              </IconButton>
            )}
          </>
        )}

        <Title>{formTitle}</Title>
      </TitleContainer>

      <Form
        ref={formRef}
        onSubmit={handleSubmit(onSubmit)}
        encType="multipart/form-data"
      >
        <Grid container spacing={1}>
          {product && field && (
            <LoaderContainer>
              <Preloader />
            </LoaderContainer>
          )}
          {product && (
            <Grid container item xs={12} spacing={3} alignItems="flex-start">
              {productColumns.map((column, columnIndex) => (
                <Grid item xs={12} md={6} key={columnIndex}>
                  <SectionColumn>
                    {column.map((section) => (
                      <Zone key={section.title} className={classes.paper}>
                        <SubTitle>{section.title}</SubTitle>
                        {section.data.map((option, optionIndex) =>
                          renderFields(option, optionIndex)
                        )}
                      </Zone>
                    ))}
                  </SectionColumn>
                </Grid>
              ))}
            </Grid>
          )}
          {field && (
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={12}>
                <Zone className={classes.paper}>
                  <SubTitle>{field.title}</SubTitle>
                  {field.data.map((option: any, idx: any) =>
                    renderFields(option, idx)
                  )}
                </Zone>
              </Grid>
            </Grid>
          )}
        </Grid>
        <ProgressBar>
          <BorderLinearProgress variant="determinate" value={progress} />
        </ProgressBar>
        <SubmitButton
          disabled={progress !== 0 && progress !== 100}
          variant="contained"
          color="primary"
          type="submit"
          startIcon={<MdSave size="1.5rem" />}
        >
          Запази
        </SubmitButton>
      </Form>
    </>
  );
};
const LoaderContainer = styled.div`
  width: 100%;
  margin: 30px 0;
`;

const SectionColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export default memo(AdminForm);
